import axios from "axios";

export const authApi = axios.create({
  // baseURL: `http://aqeelah.aldrtest.sy/api/`,
  baseURL: `https://api.alaqeelah.sy/api/`,
  // baseURL: `http://192.168.1.137:8000/api/`,
  // baseURL: `http://localhost:8000/api/`,
  headers: {
    "Content-Type": "application/json",
    // Authorization: `Bearer 14|N21egDoB3xrQBUhc7cSqrypQL98mfK0ZkEseWltK`,
  },
});
